module.exports = __webpack_public_path__ + "img/35.10.pH.14ff2299.png";